import type { LoadState } from '@/features/publicsite/types/community/LoadState';
import { isProblemStatus } from '@/services/api';

/**
 * What a forum or a topic that failed to load says: 403 is a closed forum the visitor is not a
 * member of, which the page explains; anything else reads as not found.
 */
export function forumLoadFailure(error: unknown): Extract<LoadState, 'forbidden' | 'missing'> {
  return isProblemStatus(error, 403) ? 'forbidden' : 'missing';
}
